import React from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import {
	Text,
	HStack,
	Box,
	Input,
	Button,
	Icon,
	SimpleGrid,
	Flex,
} from "@chakra-ui/react";
import { IoIosInformationCircle } from "react-icons/io";

function OpenAITab() {
	return (
		<Box>
			<Text fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold" my={3}>
				OpenAI API Key
			</Text>
			<HStack my={3}>
				<Text>Your OpenAI API Key</Text>
				<Icon as={IoIosInformationCircle} boxSize={6} color="#48484F" />
			</HStack>
			<HStack gap="10px" flexWrap="wrap">
				<Input
					w="335px"
					borderRadius="16px"
					py="12px"
					px="16px"
					placeholder="123456789"
					bg="#48484F"
					color="#969696"
				/>
				<Button bg="#48484F">Save Key</Button>
				<Button bg="#E94D3F">Remove Key</Button>
			</HStack>
		</Box>
	);
}
function PineconeDatabaseTab() {
	return (
		<Box>
			<Text fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold" my={3}>
				Pinecone Database
			</Text>
			<SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing="24px">
				<Box>
					<HStack mb={2}>
						<Text>Pinecone database API Key</Text>
						<Icon as={IoIosInformationCircle} boxSize={6} color="#48484F" />
					</HStack>
					<Input
						w="335px"
						borderRadius="16px"
						py="12px"
						px="16px"
						placeholder="123456789"
						bg="#48484F"
						color="#969696"
					/>
				</Box>
				<Box>
					<HStack mb={2}>
						<Text>Pinecone database cluster URL</Text>
						<Icon as={IoIosInformationCircle} boxSize={6} color="#48484F" />
					</HStack>
					<Input
						w="335px"
						borderRadius="16px"
						py="12px"
						px="16px"
						placeholder="www.123456789.com"
						bg="#48484F"
						color="#969696"
					/>
				</Box>
				<Flex align="end">
					<Button bg="#48484F">Test connection</Button>
				</Flex>
				<Flex align="end">
					<Button bg="#E94D3F">Disconnect</Button>
				</Flex>
			</SimpleGrid>
		</Box>
	);
}
function Connections() {
	return (
		<Tabs pt={{ base: "120px", md: "75px" }}>
			<TabList>
				<Tab>OPENAI API KEY</Tab>
				<Tab>PINECONE DATABASE</Tab>
			</TabList>

			<TabPanels>
				<TabPanel>
					<OpenAITab />
				</TabPanel>
				<TabPanel>
					<PineconeDatabaseTab />
				</TabPanel>
			</TabPanels>
		</Tabs>
	);
}

export default Connections;
